export default __webpack_public_path__ + "static/media/UnitedHealthcare.794c4c77.jpg";